import React, { PureComponent } from "react";
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Collapse,
  ButtonDropdown,
  CustomInput,
  ButtonGroup,
} from "reactstrap";
import { injectIntl } from "react-intl";

import { Colxx } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../navs/Breadcrumb";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { NotificationManager } from "../../../components/common/react-notifications";

const formatDatasExport = (data) => {
  let custs = [];

  for (let i = 0, j = data?.length; i < j; i++) {
    custs.push({
      "Tên khách hàng": data[i].name,
      "Số điện thoại": data[i].phone,
      Email: data[i].email,
      "Địa chỉ": data[i].address,
      "Số lần sử dụng": data[i].used,
      "Số điểm": data[i].point,
      "Huy hiệu": data[i].armorial,
      Tags: data[i]?.tags?.map((tag) => tag.label),
    });
  }
  return custs;
};

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = ({ csvData, fileName }) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class PageHeading extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownSplitOpen: false,
    };
  }

  handleDownloadData = () => {
    const fileName = "Danh sách khách hàng";

    exportToCSV({
      csvData: formatDatasExport(this.props.data),
      fileName,
    });
  };

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  toggleDisplayOptions = () => {
    this.setState((prevState) => ({
      displayOptionsIsOpen: !prevState.displayOptionsIsOpen,
    }));
  };

  render() {
    const { messages } = this.props.intl;
    const {
      data,
      hide_button_add,
      heading,
      setting,
      match,
      totalItem,
      toggleFunc,
      isDisabledAdd,
      changePageSizeFunc,
      onSearchKeyFunc,
      showExport = true,
      showAddNew = true,
    } = this.props;

    // console.log('render PageHeadingComponent');
    // console.log('data: ', data);

    const startIndex = (setting.currentPage - 1) * setting.selectedPageSize;
    const endIndex = setting.currentPage * setting.selectedPageSize;

    const { displayOptionsIsOpen } = this.state;
    return (
      <Row className="list-page-heading__row">
        <Colxx xxs="12">
          <div className="d-flex justify-content-between align-items-start mb-2">
            {/* Left side: Heading and Breadcrumb */}
            <div>
              <h1>
                <IntlMessages id={heading} />
              </h1>
              <Breadcrumb match={match} />
            </div>

            {/* Right side: Buttons */}
            <div className="text-zero top-right-button-container d-flex align-items-center">
              {/* Excel Download Button */}
              {showExport && (
                <Button
                  color="outline-primary"
                  className="mr-2 excel-export-pages top-right-button"
                  onClick={this.handleDownloadData}
                  title="Tải dữ liệu về file Excel"
                >
                  <i className="simple-icon-cloud-download mr-1" />
                  Excel
                </Button>
              )}

              <ButtonGroup>
                {/* Add New Button */}
                {showAddNew && (
                  <Button
                    color="primary"
                    className={classnames(
                      "top-right-button position-relative",
                      {
                        disable: hide_button_add,
                      }
                    )}
                    onClick={
                      hide_button_add
                        ? () => {
                            NotificationManager.error(
                              "Tính năng này giới hạn ở gói cước của bạn. Vui lòng nâng cấp!",
                              "Giới hạn gói cước",
                              3000,
                              null,
                              null,
                              ""
                            );
                          }
                        : () => toggleFunc()
                    }
                  >
                    <IntlMessages id="pages.add-new" />
                    {hide_button_add ? (
                      <i className="simple-icon-diamond diamond-upgrade-add" />
                    ) : null}
                  </Button>
                )}

                {/* Check All Button - Only if handler exists */}
                {/* {this.props.handleChangeSelectAll && (
                  <div className="btn btn-primary btn-lg pl-4 pr-0 check-button check-all">
                    <CustomInput
                      className="custom-checkbox mb-0 d-inline-block"
                      type="checkbox"
                      id="checkAll"
                      checked={
                        this.props.selectedItemsLength >=
                          this.props.itemsLength && this.props.itemsLength > 0
                      }
                      onChange={() => this.props.handleChangeSelectAll(true)}
                      label={
                        <span
                          className={`custom-control-label ${
                            this.props.selectedItemsLength > 0 &&
                            this.props.selectedItemsLength <
                              this.props.itemsLength
                              ? "indeterminate"
                              : ""
                          }`}
                        />
                      }
                    />
                  </div>
                )} */}

                {/* Conditional Delete Button */}
                {this.props.selectedItemsLength > 0 && (
                  <Button
                    color="danger"
                    className="top-right-button"
                    onClick={this.props.onHandlerDelete}
                  >
                    <i className="simple-icon-trash mr-1" />
                    <IntlMessages id="pages.delete" /> (
                    {this.props.selectedItemsLength})
                  </Button>
                )}
              </ButtonGroup>
            </div>
          </div>

          <div className="mb-2">
            <Button
              color="empty"
              className="pt-0 pl-0 d-inline-block d-md-none"
              onClick={this.toggleDisplayOptions}
            >
              <IntlMessages id="pages.display-options" />{" "}
              <i className="simple-icon-arrow-down align-middle" />
            </Button>
            <Collapse
              isOpen={displayOptionsIsOpen}
              className="d-md-block"
              id="displayOptions"
            >
              <div className="d-block d-md-inline-block">
                <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                  <input
                    type="text"
                    name="keyword"
                    id="search"
                    placeholder={messages["menu.search"]}
                    onKeyPress={(e) => onSearchKeyFunc(e)}
                    onChange={(e) => onSearchKeyFunc(e)}
                  />
                </div>
              </div>
              <div className="float-md-right">
                <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${totalItem} `}</span>
                <UncontrolledDropdown className="d-inline-block">
                  <DropdownToggle caret color="outline-dark" size="xs">
                    {setting.selectedPageSize}
                  </DropdownToggle>
                  <DropdownMenu right>
                    {setting.pageSizes.map((size, index) => {
                      return (
                        <DropdownItem
                          key={index}
                          onClick={() => changePageSizeFunc(size)}
                        >
                          {size}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Collapse>
          </div>
          {/* <Separator /> */}
        </Colxx>
      </Row>
    );
  }
}

export default injectIntl(PageHeading);
